import React from 'react';
import PropTypes from 'prop-types';

var MenuItem = function MenuItem(_ref) {
  var item = _ref.item;
  var label = item.label,
      icon = item.icon,
      onClick = item.onClick;


  return React.createElement(
    'span',
    {
      className: 'menuItem',
      onClick: onClick,
      key: label,
      style: { "cursor": "pointer", "fontSize": "14px", "display": "flex", "alignItems": "center", "justifyContent": "flex-start", "marginBottom": "7px" }
    },
    icon && React.createElement('img', { className: 'icon', src: icon }),
    label
  );
};

MenuItem.propTypes = process.env.NODE_ENV !== "production" ? {
  item: PropTypes.shape({
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    icon: PropTypes.string
  }).isRequired
} : {};

export default MenuItem;